import { ElementRef, Injectable } from '@angular/core';

declare var $: any; // jQuery is required for Bootstrap 4 modals

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  /**
   * Opens a modal by its DOM element or ID
   */
  open(modal: ElementRef | string) {
    const modalEl = typeof modal === 'string'
      ? document.getElementById(modal)
      : modal.nativeElement;

    if (modalEl) {
      $(modalEl).modal('show');
    } else {
      console.warn('Modal not found:', modal);
    }
  }

  /**
   * Closes a modal by its DOM element or ID
   */
  close(modal: ElementRef | string) {
    const modalEl = typeof modal === 'string'
      ? document.getElementById(modal)
      : modal.nativeElement;

    if (modalEl) {
      $(modalEl).modal('hide');
    }
  }
}
